import { ChallengeSettings } from "@/model/ChallengeSettings.model";
import { IFileModel } from "@/model/FileModel.model";
import { Game } from "@/model/Game.model";
import { User } from "@/model/User.model";
import { MutationTree } from "vuex";
import { State } from "./state";

//mutation and action enum
export enum MutationTypes {
  SET_CURRENT_USER = "SET_CURRENT_USER",
  SET_LANGUAGE = "SET_LANGUAGE",
  SET_GAME_SELECTED = "SET_GAME_SELECTED",
  SET_LIST_GAMES = "SET_LIST_GAME",
  SET_KEY_FILTER = "SET_KEY_FILTER",
  SET_KEY_SEARCH = "SET_KEY_SEARCH",
  SET_LIST_RULES = "SET_LIST_RULES",
  SET_CHALLENGES_SETTINGS = "SET_CHALLENGES_SETTINGS",
  SET_CHALLENGES_SETTING_SELECTED = "SET_CHALLENGES_SETTING_SELECTED",
  ADD_FILE_AWAIT_UPLOAD = "Add_FILE_AWAIT_UPLOAD"
}

//Mutation Types
export type Mutations<S = State> = {
  [MutationTypes.SET_CURRENT_USER](state: S, payload: User): void;
  [MutationTypes.SET_LANGUAGE](state: S, payload: string): void;
  [MutationTypes.SET_GAME_SELECTED](state: S, payload: Game): void;
  [MutationTypes.SET_LIST_GAMES](state: S, payload: Game[]): void;
  [MutationTypes.SET_CHALLENGES_SETTINGS](
    state: S,
    payload: ChallengeSettings[]
  ): void;
  [MutationTypes.SET_KEY_FILTER](state: S, payload: string[]): void;
  [MutationTypes.SET_KEY_SEARCH](state: S, payload: string): void;
  [MutationTypes.SET_CHALLENGES_SETTING_SELECTED](satate: S, payload: ChallengeSettings): void;
  [MutationTypes.ADD_FILE_AWAIT_UPLOAD](state: S, payload: IFileModel): void;
};

//define mutation
export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SET_CURRENT_USER](state: State, payload: User) {
    state.user.uid = payload.uid;
    state.user.email = payload.email;
    state.user.displayName = payload.displayName;
    state.user.phoneNumber = payload.phoneNumber;
    state.user.photoURL = payload.photoURL;
  },
  [MutationTypes.SET_LANGUAGE](state: State, payload: string) {
    state.language = payload;
  },
  [MutationTypes.SET_GAME_SELECTED](state: State, payload: Game) {
    state.gameSelected.description = payload.description;
    state.gameSelected.genre = payload.genre;
    state.gameSelected.id = payload.id;
    state.gameSelected.imageUrl = payload.imageUrl;
    state.gameSelected.name = payload.name;
  },
  [MutationTypes.SET_LIST_GAMES](state: State, payload: Game[]) {
    state.games = payload;
  },
  [MutationTypes.SET_CHALLENGES_SETTINGS](
    state: State,
    payload: ChallengeSettings[]
  ) {
    state.challengeSettings = payload;
  },
  [MutationTypes.SET_KEY_FILTER](state: State, payload: string[]) {
    state.filterGame = payload;
  },
  [MutationTypes.SET_KEY_SEARCH](state: State, payload: string) {
    state.searchGame = payload;
  },
  [MutationTypes.SET_CHALLENGES_SETTING_SELECTED](state: State, payload: ChallengeSettings) {
    state.challengeSettingSelected = payload;
  },
  [MutationTypes.ADD_FILE_AWAIT_UPLOAD](state: State, payload: IFileModel){
    state.fileAwaitUpload.push(payload);
  }
};
